import { Directive, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';

/**
 * Sets `--u` on the host to 1% of its own width, in px.
 *
 * The invite card is drawn at several sizes (the big preview, 64px picker
 * thumbnails, the zoom view, the printed card, and a fixed-width clone for
 * export), and every measurement inside it is `calc(var(--u) * n)` so the
 * layout scales as one piece. Container-query units (cqw) would do the same
 * without script, but they are missing on the older iOS and Android browsers
 * guests and hosts still use, and a px value is also what html2canvas copies
 * most reliably into the exported image.
 */
@Directive({ selector: '[appCardUnit]' })
export class CardUnitDirective implements OnInit, OnDestroy {
  private observer?: ResizeObserver;

  constructor(private el: ElementRef<HTMLElement>, private zone: NgZone) {}

  ngOnInit(): void {
    const host = this.el.nativeElement;
    const apply = (width: number) => {
      if (width > 0) host.style.setProperty('--u', `${width / 100}px`);
    };
    apply(host.offsetWidth);
    if (typeof ResizeObserver === 'undefined') return;
    // Outside Angular: a resize only changes one CSS variable, nothing bound.
    this.zone.runOutsideAngular(() => {
      this.observer = new ResizeObserver(entries => apply(entries[0].contentRect.width));
      this.observer.observe(host);
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
